/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
  checkQuarterValidation,
  compareQtrs,
  quarterTest1,
  quarterTest2,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { navigateToRequest, viewClaimDetailButton } from './ConstantData';
import { LabelerTableHead } from './tableHead';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import {
  tabHighLigther,
  autoFormateDate,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  BEGIN_QUATER_REQ,
  QTR_VALIDATION_ERR,
  VALIDATE_QUARTER_VALUE,
  ERRMSG_NOT_LABELER,
  NDC_LIMIT_TO_1000,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  dispatchErrorMsgAdjustedClaim,
  dispatchPerformAdjustedDetailObj,
  getlabelerList,
  dispatchErrorMsgNDCDetail,
  getRebateProgrameList,
  dispatchRebateProgramName,
  dispatchUnitData,
  getClaimCategoryList,
  dispatchSelectBy,
  dispatchDrugData,
  dispatchLabelerInfo,
  dispatchUnitChangedType,
  dispatchDisputeResolution,
  dispatchInvoiceStatus,
  dispatchQtrRange,
  dispatchClaimCategoryName,
  getLabelerInfoList,
  getDrugSeqList,
  dispatchDrugSeqDetail,
  dispatchLabelerInfoName,
  getUnitList,
  getAdjustedClaimList,
  getDrugNameList,
  dispatchDisplayObjAdjusted,
  setLoadedClaimLoad,
  dispatchLabelerSelection,
  setDetailsPagination,
  dispatchAdjustedClaim,
  dispatchProviderCd
} from '../Store/action';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const AdjustedClaims = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.AdjustedClaimReducer?.performAdjustedResolutionObj
  );

  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.rebateProgram
  );
  const getRebateProgramNameList = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.rebateProgramName
  );

  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.errorMsgAdjustedClaim
  );

  const labelerListData = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.labelerList
  );
  const getlabelerInfo = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.labelerInfo
  );
  const claimListData = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.claimCategory
  );

  const {
    billed,
    notBilled,
    yes,
    no,
    invoice,
    nonInvoiced,
    selectedNDC,
    ndcLeftTableData: ndcLeftTableDataArr,
    labelerSelectedRow: labelerSelectedRowValue,
    selectRowIndex,
    selectedSearchType,
  } = useSelector((state) => state?.sharedState?.AdjustedClaimReducer);
  const getUnitListData = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.unitGrid
  );

  const {
    startQtr: startQtrValue,
    endQtr: endQtrValue,
    selectBy: selectByValue,
    claimcategorySelectedValue,
  } = useSelector((state) => state?.sharedState?.AdjustedClaimReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const drugSeqData = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.drugSeqNum
  );
  const dispatch = useDispatch();
  const gridRef = useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [selectBy, setSelectBy] = React.useState(selectByValue);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [searchType, setSearchType] = React.useState(selectedSearchType);
  const [drugNum, setDrugNum] = React.useState([]);
  const [labelerList, setLabelerList] = React.useState();
  const [claimcategory, setClaimcategory] = React.useState();
  const [labelerCodeData, setLabelerCodeData] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [startQtr, setStartQtr] = React.useState(startQtrValue);
  const [endQtr, setEndQtr] = React.useState(endQtrValue);
  const [validatedStartQtr, setValidatedStartQtr] = React.useState();
  const [validatedEndQtr, setValidatedEndQtr] = React.useState();
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [selectesNdc, setSelectedNdc] = React.useState([]);
  const [warningMsgAlert, setWarningMsgAlert] = React.useState(false);
  const [checkboxValuesUnit, setCheckboxValuesUnit] = React.useState({
    billed: billed,
    notBilled: notBilled,
  });
  const [checkboxValuesDispute, setCheckboxValuesDispute] = React.useState({
    yes: yes,
    no: no,
  });
  const [checkboxValuesInvoice, setCheckboxValuesInvoice] = React.useState({
    invoice: invoice,
    nonInvoiced: nonInvoiced,
  });
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  React.useEffect(() => {
    setSelectBy(selectByValue);
  }, [selectByValue]);
  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgNDCDetail({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          rebateProgramCd:
            userDefaults?.rebateProgramCd ||
            getRebateProgramNameList?.rebateProgramCd
              ? getRebateProgramNameList?.rebateProgramCd ||
                userDefaults?.rebateProgramCd
              : '-1',
          claimcategorySelected: claimcategorySelectedValue,
          billed: true,
          notBilled: false,
          yes: true,
          no: false,
          invoice: true,
          nonInvoiced: false,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );

  const searchCompObj = requestCurrentDisData?.state?.searchTypeState;
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    labelerSelectedRowValue
  );

  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] =
    React.useState(ndcLeftTableDataArr);
  const [ndcRightTableData, setNdcRightTableData] = React.useState(selectedNDC);
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );

  // dispatch function
  const setPerformClaimScrData = (value) =>
    dispatch(dispatchPerformAdjustedDetailObj(value));

  // get rebate program list
  React.useEffect(() => {
    handleScrollToEvent();
    if (_.isEmpty(getRebateProgramList)) {
      rebatepgmDropdown();
    }
  }, []);
  // set Rebate Program List
  const rebatepgmDropdown = async () => {
    const getRebateProgramData = await dispatch(getRebateProgrameList());
    let list = [];
    if (
      getRebateProgramData?.status === STATUS_MSG &&
      getRebateProgramData?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramData.data)) {
        list = _.map(getRebateProgramData.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    if (name === 'selectBy' && value !== state.selectBy) {
      setState({
        ...state,
        [name]: value,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');
      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setPerformClaimScrData({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          [name]: value,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      localErr = localErr.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      setErrorMsgFromSearchType([]);
    }

    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformClaimScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
  };
  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg?.searchScreenErrors || [];
    const data = value;
    if (type === 'startQtr' || type === 'endQtr') {
      value = autoFormateDate(data);
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (checkQuarterValidation(value)) {
          if (type === 'startQtr') {
            localErr = localErr?.filter((item) => item.field !== 'startQtr');
          }
          if (type === 'endQtr') {
            localErr = localErr?.filter((item) => item.field !== 'endQtr');
          }
          if (value.length === 4) {
            value = autoFormateDate(value);
          }
          setState({ ...state, [type]: value?.toUpperCase() });
          let startDate = state.startQtr;
          let { endQtr } = state;
          if (type === 'endQtr') {
            endQtr = value;
            setEndQtr(value);
          } else {
            startDate = value;
            setStartQtr(value);
          }
          if (
            checkQuarterValidation(startQtr) &&
            checkQuarterValidation(endQtr)
          ) {
            if (compareQtrs(startQtr, endQtr)) {
              localErr.push({
                field: type,
                errorType: 'rangeInvalid',
                message: QTR_VALIDATION_ERR,
              });
            } else {
              localErr = localErr?.filter(
                (item) => item.errorType !== 'rangeInvalid'
              );
            }
          }
        } else {
          localErr =
            localErr && localErr?.filter((item) => item.field !== type);
          localErr.push({
            field: type,
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr =
          localErr && localErr?.filter((item) => item.field !== 'startQtr');
        if (type === 'startQtr') {
          localErr.push({
            field: 'startQtr',
            errorType: 'startQtrRequired',
            message: BEGIN_QUATER_REQ,
          });
        }
      }
      if (
        !endQtr &&
        !localErr.filter((o) => o.field === 'startQtr').length &&
        type === 'startQtr'
      )
        setEndQtr(value);
    }

    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }
    const noErrorStart = localErr.filter((item) => item.field == 'startQtr');
    // if (noErrorStart.length == 0) {
    //   setValidatedStartQtr(startQtr);
    // }
    const noErrorEnd = localErr.filter((item) => item.field == 'endQtr');
    // if (noErrorEnd.length == 0) {
    //   setValidatedEndQtr(endQtr);
    // }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
  };
  // Labeler Grid From API
  React.useEffect(() => {
    setLabelerList(labelerListData?.drugFamilyVOs);
  }, [labelerListData]);
  React.useEffect(() => {
    dispatch(
      getlabelerList({
        searchType: 'labeler',
      })
    );
  }, []);
  // labeler code api
  React.useEffect(() => {
    setLabelerCodeData(getlabelerInfo?.drugFamilyVOs);
  }, [getlabelerInfo]);
  React.useEffect(() => {
    if (selectedRows.length > 0) {
      dispatch(
        getLabelerInfoList({
          labelerCode: selectedRows[0].labelerCode,
        })
      );
    }
  }, [selectedRows]);
  // current Quarter
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
  const currentYear = currentDate.getFullYear();
  const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter

  const formattedQuarter = `${currentQuarter}Q${currentYear.toString()}`;
  // adjusted grid drug seq if all is selected
  React.useEffect(() => {
    if (drugSeqData && drugSeqData.adjustedClaimsGetDrugSeqNumberALLVO) {
      const sortedDrugNum =
        drugSeqData.adjustedClaimsGetDrugSeqNumberALLVO.sort((a, b) =>
          a.ndc > b.ndc ? 1 : -1
        );
      setDrugNum(sortedDrugNum);
      if (sortedDrugNum.length) {
        dispatch(dispatchDrugSeqDetail(sortedDrugNum));
      }
    }
  }, [drugSeqData, dispatch]);

  const handleResult = (name, value) => {
    const startQtrError = checkQuarterValidation(startQtr);
    let beginQtr = name === 'startQtr' ? value : startQtr;
    const endQtrVal = name === 'endQtr' ? value : endQtr;
    const rebateProgramCode =
      name === 'rebateProgramCd' ? value : state?.rebateProgramCd;

    let endQtrError = true;
    if (endQtrVal?.trim()?.length > 0) {
      endQtrError = checkQuarterValidation(endQtrVal);
    }
    if (startQtrError && beginQtr.length === 4) {
      beginQtr = autoFormateDate(beginQtr);
      // setStartQtr(beginQtr)
    }
    let toQtr = endQtrVal;
    if (endQtrError && endQtrVal?.trim().length === 4) {
      toQtr = autoFormateDate(endQtrVal);
      // setEndQtr(toQtr)
    }
    // if (selectBy == 'All' && startQtrError && endQtrError) {
    //   dispatch(
    //     getDrugSeqList({
    //       rebateProgramCd: rebateProgramCode,
    //       startQuarter: beginQtr,
    //       endQuarter: toQtr,
    //       //|| formattedQuarter
    //     })
    //   );
    // }
  };
  // claim category From API
  React.useEffect(() => {
    let data1 =
      claimListData?.CLAIM_CATEGORY_CD?.map((item) => {
        return {
          ...item,
          codeValuetemp: item.codeValueID.codeValue,
          name: `${item.codeValueID.codeValue} |  ${item.shortDescription}`,
          id: `${item.codeValueID.codeValue} |  ${item.shortDescription}`,
        };
      }) || [];

    data1 = [
      {
        id: 'ALL | Applies to all Categories',
        name: 'ALL | Applies to all Categories',
      },
      ...data1,
    ];
    setState({
      ...state,
      claimcategorySelected: claimcategorySelectedValue || data1[0]?.name,
    });
    setClaimcategory(data1);
    
    const simplifiedArray = claimListData?.PROVIDER_ID_TYPE_CD?.map(item => ({
      codeValue: item?.codeValueID?.codeValue,
      shortDescription: item?.shortDescription
    }));
    dispatch(dispatchProviderCd(simplifiedArray))
  }, [claimListData]);

  React.useEffect(() => {
    dispatch(
      getClaimCategoryList({
        codeDomainList: ['CLAIM_CATEGORY_CD','PROVIDER_ID_TYPE_CD'],
      })
    );
  }, []);
  const stringParts = state?.claimcategorySelected?.split(' | ');
  const claimShort = stringParts[0]?.trim();

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg?.searchScreenErrors?.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [getErrorMsg]);

  // Grid functionality for labeler
  const onSelectionChanged = (e) => {
    let selectedRows = e.api.getSelectedRows();
    setSelectedRows(selectedRows);
    dispatch(dispatchLabelerSelection(selectedRows));
    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field != 'nolabeler');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
  };

  // Search button on click functionality
  const onClickOnSearch = async (e) => {
    const rebateProgramName = rebateProgramList?.find(
      (item) => item.id == state.rebateProgramCd
    );

    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field !== 'noData');

    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const sRows = (selectBy === 'Labeler' ? selectedRows : labelerList) || [];
    if (sRows.length === 0) {
      localErr.push({
        field: 'nolabeler',
        errorType: 'labelerRequired',
        message: ERRMSG_NOT_LABELER,
      });
    }
    if (!startQtr) {
      localErr = localErr.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'startQtrRequired',
        message: BEGIN_QUATER_REQ,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
    if (
      state.rebateProgramCd === '-1' ||
      sRows.length === 0 ||
      localErr.length > 0
    ) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return;
    }
    if (
      (!checkboxValuesUnit?.billed && !checkboxValuesUnit?.notBilled) ||
      (!checkboxValuesDispute?.yes && !checkboxValuesDispute?.no) ||
      (!checkboxValuesInvoice?.invoice && !checkboxValuesInvoice?.nonInvoiced)
    ) {
      setWarningMsgAlert(true);
    } else {
      setWarningMsgAlert(false);
      try {
        let drugSeqNumber, drugSeqResponse;
        if (selectBy === 'All') {
          drugSeqResponse = await dispatch(
            getDrugSeqList({
              rebateProgramCd: rebateProgramName?.rebateProgramCd,
              startQuarter: startQtr,
              endQuarter: endQtr || startQtr,
            })
          );
          drugSeqNumber =
            drugSeqResponse?.adjustedClaimsGetDrugSeqNumberALLVO?.map(
              (o) => o.drugSeqNum
            );
          // drugSeqResponse?.adjustedClaimsGetDrugSeqNumberALLVO[0]?.drugSeqNum ||
          // '';
        } else if (selectBy === 'Labeler')
          // drugSeqNumber = drugNum.length > 0 ? drugNum[0]?.drugSeqNum : '';
          drugSeqNumber = labelerCodeData.map((o) => o.drugSeqNum);

        let index = labelerList?.findIndex(
          (obj) => obj.labelerCode === selectedRows[0]?.labelerCode
        );
        index = index === -1 ? 0 : index;
        // const selectByBasis = {
        //   Labeler: {
        //     drugSeqNumber: labelerCodeData ? labelerCodeData[0]?.drugSeqNum : '',
        //   },
        //   All: {
        //     drugSeqNumber: drugSeqNumber,
        //   },
        // };

        // setSearchClicked(true);
        // dispatch(dispatchUnitData([]));
        // dispatch(
        //   getDrugSeqList({
        //     rebateProgramCd: rebateProgramName?.rebateProgramCd,
        //     startQuarter: startQtr,
        //     endQuarter: endQtr || startQtr,
        //     //|| formattedQuarter
        //   })
        // );
        // dispatch(
        //   getUnitList({
        //     drugSeqNumber: selectByBasis[selectBy].drugSeqNumber,
        //   })
        // );
        if (!endQtr) {
          setEndQtr(startQtr);
        }
        let response = [];
        for (let i = 0; i < drugSeqNumber.length; i = i + 1000) {
          let curr = await dispatch(
            getAdjustedClaimList({
              drugSeqNumber: drugSeqNumber.slice(i, i + 1000),
              startQuarter: startQtr,
              endQuarter: endQtr || startQtr,
              rebateProgram: rebateProgramName?.rebateProgramCd,
              invoiceInd: checkboxValuesInvoice.invoice ? 1 : 0,
              nonInvoiceInd: checkboxValuesInvoice.nonInvoiced ? 1 : 0,
              disputeCheck: checkboxValuesDispute.yes ? 1 : 0,
              disputeuncheck: checkboxValuesDispute.no ? 1 : 0,
              billedUnits: checkboxValuesUnit.billed ? 1 : 0,
              notBilledUnits: checkboxValuesUnit.notBilled ? 1 : 0,
              claimCategory: claimShort,
              useType:
                selectBy === 'All' ? 'A' : selectBy === 'NDC' ? 'N' : 'M',
              mfgId: selectBy === 'Labeler' ? sRows?.[0].labelerCode : '',
            })
          );
          response = [...response, ...curr];
        }

        dispatch(setLoadedClaimLoad(false));
        if (response.length) {
          const grpBy = Object.groupBy(
            response,
            ({ drugSeqNum }) => drugSeqNum
          );
          const drugSeqNums = Object.keys(grpBy);
          let list;
          if (selectBy === 'All') {
            list = drugSeqResponse?.adjustedClaimsGetDrugSeqNumberALLVO?.filter(
              (o) => drugSeqNums.indexOf(o.drugSeqNum.toString()) !== -1
            );
          } else if (selectBy === 'Labeler') {
            list = labelerCodeData?.filter(
              (o) => drugSeqNums.indexOf(o.drugSeqNum.toString()) !== -1
            );
          }
          dispatch(setDetailsPagination(list));
          dispatch(dispatchLabelerInfoName(list));
          dispatch(
            dispatchAdjustedClaim(response, {
              billed: checkboxValuesUnit.billed,
              notBilled: checkboxValuesUnit.notBilled,
              yes: checkboxValuesDispute.yes,
              no: checkboxValuesDispute.no,
              invoice: checkboxValuesInvoice.invoice,
              nonInvoiced: checkboxValuesInvoice.nonInvoiced,
            })
          );
          redirectURLLink(
            '/DisplayAdjustedClaims',
            'Adjusted Claims Report',
            props.history
          );
          dispatch(clearReduxForFilterAndSort('/DisplayAdjustedClaims'));
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        // dispatch(
        //   getDrugNameList({
        //     drugSeqNumber: selectByBasis[selectBy].drugSeqNumber,
        //   })
        // );

        dispatch(dispatchRebateProgramName(rebateProgramName));
        dispatch(dispatchQtrRange({ selectRowIndex: index, startQtr, endQtr }));
        dispatch(dispatchSelectBy(selectBy));

        // dispatch(dispatchLabelerInfoName(labelerCodeData));

        dispatch(
          dispatchClaimCategoryName({
            claimcategorySelectedValue: state?.claimcategorySelected,
          })
        );
        dispatch(
          dispatchUnitChangedType({
            billed: checkboxValuesUnit.billed,
            notBilled: checkboxValuesUnit.notBilled,
          })
        );
        dispatch(
          dispatchDisputeResolution({
            yes: checkboxValuesDispute.yes,
            no: checkboxValuesDispute.no,
          })
        );
        dispatch(
          dispatchInvoiceStatus({
            invoice: checkboxValuesInvoice.invoice,
            nonInvoiced: checkboxValuesInvoice.nonInvoiced,
          })
        );
        dispatch(
          dispatchDisplayObjAdjusted({
            rebateProgramName,
            claimcategorySelectedValue: state?.claimcategorySelected,
            startQtr,
            endQtr,
            labelerCodeData,
            drugNum,
            billed: checkboxValuesUnit.billed,
            notBilled: checkboxValuesUnit.notBilled,
            yes: checkboxValuesDispute.yes,
            no: checkboxValuesDispute.no,
            invoice: checkboxValuesInvoice.invoice,
            nonInvoiced: checkboxValuesInvoice.nonInvoiced,
            selectBy,
          })
        );
      } catch (error) {}
    }
  };

  // if (
  //   isSearchClicked &&
  //   getUnitListData?.adjustedClaimsUnitGridVO?.length > 0
  // ) {
  //   setSearchClicked(false);
  //   dispatch(setLoadedClaimLoad(false));
  //   redirectURLLink(
  //     '/DisplayAdjustedClaims',
  //     'Adjusted Claims Report',
  //     props.history
  //   );
  //   dispatch(clearReduxForFilterAndSort('/DisplayAdjustedClaims'));
  // }

  // ndc search
  const onSearch = async (data, bypass = true) => {
    const rebateProgramName = rebateProgramList?.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg?.searchScreenErrors || [];
    localErr = localErr.filter((item) => item.field != 'noData');

    if (!startQtr) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'startQtrRequired',
        message: BEGIN_QUATER_REQ,
      });
    }

    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
    if (state.rebateProgramCd === '-1' || localErr.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      return;
    }
    if (
      (!checkboxValuesUnit?.billed && !checkboxValuesUnit?.notBilled) ||
      (!checkboxValuesDispute?.yes && !checkboxValuesDispute?.no) ||
      (!checkboxValuesInvoice?.invoice && !checkboxValuesInvoice?.nonInvoiced)
    ) {
      setWarningMsgAlert(true);
    } else {
      setWarningMsgAlert(false);
      // selection basis-select by
      if (localErr.length == 0) {
        if (!bypass) {
          setConfirmAction(true);
          setSelectedNdc(data);
          return;
        }
        const selectByBasis = {
          // Labeler: {
          //   drugSeqNumber: getLabelerDataList[0]?.drugSeqNum,
          // },
          NDC: {
            drugSeqNumber: data[0]?.drugSeqNum,
          },
          // All: {
          //   drugSeqNumber: drugNum ? drugNum[0]?.drugSeqNum : '',
          // },
        };
        // dispatch(dispatchUnitData([]));
        // setSearchClicked(true);
        // dispatch(
        //   getUnitList({
        //     drugSeqNumber: selectByBasis[selectBy].drugSeqNumber,
        //   })
        // );
        let response = await dispatch(
          getAdjustedClaimList({
            drugSeqNumber:
              data
                ?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1))
                ?.filter((o, ind) => ind < 1000)
                ?.map((o) => o.drugSeqNum) || [],
            startQuarter: startQtr,
            endQuarter: endQtr || '2Q2023',
            rebateProgram: rebateProgramName?.rebateProgramCd,
            invoiceInd: checkboxValuesInvoice.invoice ? 1 : 0,
            nonInvoiceInd: checkboxValuesInvoice.nonInvoiced ? 1 : 0,
            disputeCheck: checkboxValuesDispute.yes ? 1 : 0,
            disputeuncheck: checkboxValuesDispute.no ? 1 : 0,
            billedUnits: checkboxValuesUnit.billed ? 1 : 0,
            notBilledUnits: checkboxValuesUnit.notBilled ? 1 : 0,
            claimCategory: claimShort,
            useType: selectBy === 'All' ? 'A' : selectBy === 'NDC' ? 'N' : 'M',
            mfgId: '',
          })
        );
        let list;
        dispatch(setLoadedClaimLoad(false));
        if (response.length) {
          const grpBy = Object.groupBy(
            response,
            ({ drugSeqNum }) => drugSeqNum
          );
          const drugSeqNums = Object.keys(grpBy);
          list = data?.filter(
            (o) => drugSeqNums.indexOf(o.drugSeqNum.toString()) !== -1
          );
          dispatch(setDetailsPagination(list));
          redirectURLLink(
            '/DisplayAdjustedClaims',
            'Adjusted Claims Report',
            props.history
          );
          dispatch(clearReduxForFilterAndSort('/DisplayAdjustedClaims'));
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        // dispatch(
        //   getDrugNameList({
        //     drugSeqNumber: selectByBasis[selectBy].drugSeqNumber,
        //   })
        // );
        dispatch(dispatchRebateProgramName(rebateProgramName));
        dispatch(
          dispatchClaimCategoryName({
            claimcategorySelectedValue: state?.claimcategorySelected,
          })
        );
        dispatch(
          dispatchQtrRange({ selectedSearchType: searchType, startQtr, endQtr })
        );
        dispatch(dispatchSelectBy(selectBy));
        dispatch(
          dispatchDrugData({
            selectedNDC: data,
            ndcLeftTableData,
            labelerSelectedRow,
          })
        );

        dispatch(
          dispatchUnitChangedType({
            billed: checkboxValuesUnit.billed,
            notBilled: checkboxValuesUnit.notBilled,
          })
        );
        dispatch(
          dispatchDisputeResolution({
            yes: checkboxValuesDispute.yes,
            no: checkboxValuesDispute.no,
          })
        );
        dispatch(
          dispatchInvoiceStatus({
            invoice: checkboxValuesInvoice.invoice,
            nonInvoiced: checkboxValuesInvoice.nonInvoiced,
          })
        );
        dispatch(
          dispatchDisplayObjAdjusted({
            rebateProgramName,
            claimcategorySelectedValue: state?.claimcategorySelected,

            startQtr,
            endQtr,

            selectedNDC: data,
            ndcLeftTableData,
            labelerSelectedRow,
            billed: checkboxValuesUnit.billed,
            notBilled: checkboxValuesUnit.notBilled,
            yes: checkboxValuesDispute.yes,
            no: checkboxValuesDispute.no,
            invoice: checkboxValuesInvoice.invoice,
            nonInvoiced: checkboxValuesInvoice.nonInvoiced,
            selectBy,
            drugData: list?.length ? list : data,
          })
        );
      }
    }
  };

  // if (
  //   isSearchClicked &&
  //   getUnitListData?.adjustedClaimsUnitGridVO?.length > 0
  // ) {
  //   setSearchClicked(false);
  //   const updateTabs =
  //     JSON.parse(localStorage.getItem('tabItemsData')) === null
  //       ? []
  //       : JSON.parse(localStorage.getItem('tabItemsData'));
  //   updateTabs.push({
  //     navTo: '/DisplayAdjustedClaims',
  //     value: 'Adjusted Claims Report',
  //   });
  //   localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  //   props.history.push({
  //     pathname: '/DisplayAdjustedClaims',
  //   });
  //   dispatch(clearReduxForFilterAndSort('/DisplayAdjustedClaims'));
  // }

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformClaimScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  // setting Quarter From
  const handleFromChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setStartQtr(value);
    let localErr = getErrorMsg?.searchScreenErrors || [];

    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
  };
  // setting Quarter To
  const handleToChange = (event) => {
    let { value } = event.target;
    if (value?.includes('q')) {
      value = value?.replace('q', 'Q');
    }
    setEndQtr(value);
    let localErr = getErrorMsg?.searchScreenErrors || [];

    localErr = localErr.filter((item) => item.field !== 'endQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgAdjustedClaim({ searchScreenErrors: unique }));
  };
  // For No Data validation autoScroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.searchScreenErrors?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);

  // const cellClickedListener = (e) => {
  //   onClickOnSearch();
  // };
  return (
    <div
      className="tabs-container  tBillPanel custom-check"
      data-testid="adjusted-claims"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Detail Reports" parent2="Adjusted Claims" />
      {getErrorMsg?.searchScreenErrors?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.searchScreenErrors?.length > 0
                ? _.map(getErrorMsg?.searchScreenErrors, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null}
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-4 frr-two-col-radio ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Claim Category Cd<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="claimCategory"
                      id="claim_category"
                      data-testid="req-NDC-payment-quarter"
                      label="Claim Category Cd"
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'claim_category' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        setState({
                          ...state,
                          claimcategorySelected: e.target.value,
                        });
                      }}
                      value={
                        state && state.claimcategorySelected
                          ? state.claimcategorySelected
                          : ''
                      }
                    >
                      {claimcategory?.length > 0
                        ? claimcategory.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4 frr-two-col-radio ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Rebate Program<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="rebateProgram"
                      id="rebate_program"
                      data-testid="req-rbt-prg"
                      label="Rebate Program"
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? _.map(getErrorMsg?.searchScreenErrors, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd');
                        handleResult('rebateProgramCd', e.target.value);
                      }}
                      value={
                        state && state.rebateProgramCd
                          ? state.rebateProgramCd
                          : ''
                      }
                      error={
                        getErrorMsg?.searchScreenErrors?.length > 0 &&
                        getErrorMsg?.searchScreenErrors?.filter((x) => {
                          return x.field === 'rebateProgramCd';
                        }).length > 0
                          ? [
                              ...new Set(
                                getErrorMsg?.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'rebateProgramCd';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                      helperText={
                        getErrorMsg?.searchScreenErrors?.length > 0
                          ? [
                              ...new Set(
                                getErrorMsg?.searchScreenErrors
                                  ?.filter((x) => {
                                    return x.field === 'rebateProgramCd';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Quarter Range<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <RadioGroup row name="date-range">
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              label="Begin"
                              id="Begin"
                              data-testid="req-begin"
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={startQtr}
                              onChange={handleFromChange}
                              onBlur={(e) => {
                                handleOnblurEvent('startQtr', e.target.value);
                                //handleResult('startQtr', e.target.value);
                              }}
                              inputProps={{ maxLength: 6 }}
                              name="start"
                              helperText={
                                getErrorMsg?.searchScreenErrors?.length > 0
                                  ? _.map(
                                      getErrorMsg?.searchScreenErrors,
                                      (l) =>
                                        l.field === 'startQtr'
                                          ? l.message
                                          : null
                                    )
                                  : null
                              }
                              className={
                                getErrorMsg?.searchScreenErrors?.length > 0
                                  ? _.map(
                                      getErrorMsg?.searchScreenErrors,
                                      (l) =>
                                        l.field == 'startQtr'
                                          ? 'mandate-fields'
                                          : null
                                    )
                                  : null
                              }
                              error={
                                getErrorMsg?.searchScreenErrors?.length > 0 &&
                                getErrorMsg?.searchScreenErrors?.filter((x) => {
                                  return x.field === 'startQtr';
                                }).length > 0
                                  ? [
                                      ...new Set(
                                        getErrorMsg?.searchScreenErrors
                                          ?.filter((x) => {
                                            return x.field === 'startQtr';
                                          })
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label="End"
                              id="End"
                              data-testid="req-end"
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{ maxLength: 6 }}
                              name="end"
                              value={endQtr}
                              onChange={handleToChange}
                              onBlur={(e) => {
                                handleOnblurEvent('endQtr', e.target.value);
                                handleResult('endQtr', e.target.value);
                              }}
                              helperText={
                                getErrorMsg?.searchScreenErrors?.length > 0
                                  ? _.map(
                                      getErrorMsg?.searchScreenErrors,
                                      (l) =>
                                        l.field === 'endQtr' ? l.message : null
                                    )
                                  : null
                              }
                              className={
                                getErrorMsg?.searchScreenErrors?.length > 0
                                  ? _.map(
                                      getErrorMsg?.searchScreenErrors,
                                      (l) =>
                                        l.field == 'endQtr'
                                          ? 'mandate-fields'
                                          : null
                                    )
                                  : null
                              }
                              error={
                                getErrorMsg?.searchScreenErrors?.length > 0 &&
                                getErrorMsg?.searchScreenErrors?.filter((x) => {
                                  return x.field === 'endQtr';
                                }).length > 0
                                  ? [
                                      ...new Set(
                                        getErrorMsg?.searchScreenErrors
                                          ?.filter((x) => {
                                            return x.field === 'endQtr';
                                          })
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row">
            <div className="col-6 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Unit Changed Type</legend>
                <div className="form-wrapper p-2">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <RadioGroup row name="report-quarter" required>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValuesUnit.billed}
                            color="primary"
                            name="Billed Units"
                            onChange={(e) => {
                              setCheckboxValuesUnit({
                                ...checkboxValuesUnit,
                                billed: !checkboxValuesUnit.billed,
                              });
                            }}
                          />
                        }
                        label="Billed Units"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValuesUnit.notBilled}
                            color="primary"
                            name="Not Billed Units"
                            onChange={(e) => {
                              setCheckboxValuesUnit({
                                ...checkboxValuesUnit,
                                notBilled: !checkboxValuesUnit.notBilled,
                              });
                            }}
                          />
                        }
                        label="Not Billed Units"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-6 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Invoice Status</legend>
                <div className="form-wrapper p-2">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <RadioGroup row name="report-quarter" required>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValuesInvoice.invoice}
                            color="primary"
                            name="Invoiced"
                            onChange={(e) => {
                              setCheckboxValuesInvoice({
                                ...checkboxValuesInvoice,
                                invoice: !checkboxValuesInvoice.invoice,
                              });
                            }}
                          />
                        }
                        label="Invoiced"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValuesInvoice.nonInvoiced}
                            color="primary"
                            name="Non Invoiced"
                            onChange={(e) => {
                              setCheckboxValuesInvoice({
                                ...checkboxValuesInvoice,
                                nonInvoiced: !checkboxValuesInvoice.nonInvoiced,
                              });
                            }}
                          />
                        }
                        label="Non Invoiced"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  For Dispute Resolution
                </legend>
                <div className="form-wrapper p-2">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <RadioGroup row name="report-quarter" required>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValuesDispute.yes}
                            color="primary"
                            name="Yes"
                            onChange={(e) => {
                              setCheckboxValuesDispute({
                                ...checkboxValuesDispute,
                                yes: !checkboxValuesDispute.yes,
                              });
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValuesDispute.no}
                            color="primary"
                            name="No"
                            onChange={(e) => {
                              setCheckboxValuesDispute({
                                ...checkboxValuesDispute,
                                no: !checkboxValuesDispute.no,
                              });
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-sm-8">
              <RadioGroupComponent
                data-testid="checkAllocation-totals-details"
                id="filter-plan-by-radio-btn-action"
                labelName="Select By"
                required
                optionList={[
                  {
                    name: 'Labeler',
                    value: 'Labeler',
                  },
                  {
                    name: 'NDC',
                    value: 'NDC',
                  },
                  {
                    name: 'Select All For Above Criteria',
                    value: 'All',
                  },
                ]}
                defaultValue={selectBy}
                filterAction={(value) => {
                  setSelectBy(value);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
          </div>
        </>
      )}
      <div className="row">
        {selectBy == 'NDC' && (
          <div className="col-sm-12">
            <SearchTypeComponent
              id="claimAuditSelect"
              data-testid="claim-audit-select-Ndc-Component"
              viewDetailButtonName={viewClaimDetailButton}
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={(l) => onSearch(l, l.length < 1000)}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
              iconName="search"
            />
          </div>
        )}
      </div>

      <div className="col-12 btn-wrapper mb-2">
        <div className="float-right mt-2 hide-on-print">
          {selectBy == 'Labeler' && (
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={onClickOnSearch}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          )}
        </div>
      </div>
      <div className="col-12 btn-wrapper mb-2">
        <div className="float-right mt-2 hide-on-print">
          {selectBy == 'All' && (
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={onClickOnSearch}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          )}
        </div>
      </div>
      <br />
      <br />
      {selectBy == 'Labeler' && (
        <div className="panel-body FRR-custom-table tbl-labeler-inner">
          <TableGrid
            onSelectionChanged={onSelectionChanged}
            ref={gridRef}
            data-testid="labeler-grid"
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            columnDefs={LabelerTableHead}
            rowData={labelerList}
            rowMultiSelectWithClick
            exportFile
            animateRows
            selectRowIndex={selectRowIndex}
            // cellClickedListener={cellClickedListener}
            fileName="labeler Grid"
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            isScrollOn
            defaultColWidth={200}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      )}
      <CommonModal
        open={confirmAction}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          setConfirmAction(false);
          onSearch(selectesNdc, true);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setConfirmAction(false)}
        modalTitle="Confirmation Dialog"
        childrenComponent={NDC_LIMIT_TO_1000}
      />

      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={warningMsgAlert}
        viewAction
        viewHeader
        onOk={() => {
          setWarningMsgAlert(false);
        }}
        onClose={() => {
          setWarningMsgAlert(false);
        }}
        modalTitle="Request Adjusted Claims Report"
        okTitle="Ok"
        childrenComponent={
          <div className="p-1">
            {!checkboxValuesInvoice?.invoice &&
              !checkboxValuesInvoice?.nonInvoiced && (
                <p>You must check one of the Invoice Status check boxes.</p>
              )}

            {!checkboxValuesUnit?.billed && !checkboxValuesUnit?.notBilled && (
              <p>You must check one of the Unit Change Type check boxes.</p>
            )}
            {!checkboxValuesDispute?.yes && !checkboxValuesDispute?.no && (
              <p>You must check one of the Dispute Resolution check boxes.</p>
            )}
          </div>
        }
      />
    </div>
  );
};

export default AdjustedClaims;
